<script lang="ts" setup>
import { useFuncionario } from '~/composables/gerencial/useFuncionario'
import { useUsuario } from '~/composables/gerencial/useUsuario'

const emit = defineEmits(['close'])
const { updatePassword, user } = useAuthStore()

const props = defineProps<{
  id?: number
}>()

const userId = props.id ? props.id : (await useFuncionario().getField(user.id, 'cd_usuario'))
const description = await useUsuario().getField(userId, 'ds_usuario')

const showPassword = ref(false)
const showConfirm = ref(false)

const onSubmit = async (data) => {
  try {
    const payload = { ...data, id: userId }
    await updatePassword(payload)
    useMessage().showMessage('Senha atualizada com sucesso !')
    emit('close')
  } catch (error) {
    console.error(error)
  }
}

const userPhoto = ref('')

const loadUserPhoto = async () => {
  const blob = await useUsuario().getBlob(userId, 'bb_foto', 'foto.jpg', false).catch(() => null)
  if (blob?.size)
    userPhoto.value = await useFileDownload().blobToBase64(blob)
}

onMounted(async () => {
  await loadUserPhoto()
})
</script>

<template>
  <ModalFullScreen
    title="Alterar senha"
    :description
  >
    <NuxtImg
      :src="userPhoto"
      class="max-h-32 w-auto object-contain mx-auto"
    />
    <FormKit
      dirty-behavior="compare"
      type="form"
      submit-label="Salvar"
      @submit="onSubmit"
    >
      <FormKit
        :type="showPassword ? 'text' : 'password'"
        name="password"
        label="Nova Senha"
        validation="required"
        validation-visibility="live"
      >
        <template #suffix>
          <button
            type="button"
            class="px-2 text-gray-400 hover:text-gray-600 focus:outline-none"
            @click="showPassword = !showPassword"
          >
            <UIcon
              :name="showPassword ? 'i-heroicons-eye-slash' : 'i-heroicons-eye'"
              class="size-4"
            />
          </button>
        </template>
      </FormKit>
      <FormKit
        :type="showConfirm ? 'text' : 'password'"
        name="password_confirm"
        label="Confirmar Senha"
        validation="required|confirm|length:6"
        validation-visibility="live"
        validation-label="Confirmação de senha"
      >
        <template #suffix>
          <button
            type="button"
            class="px-2 text-gray-400 hover:text-gray-600 focus:outline-none"
            @click="showConfirm = !showConfirm"
          >
            <UIcon
              :name="showConfirm ? 'i-heroicons-eye-slash' : 'i-heroicons-eye'"
              class="size-4"
            />
          </button>
        </template>
      </FormKit>
    </FormKit>
  </ModalFullScreen>
</template>
